import { find } from "lodash";
import { generatePath, matchPath } from "react-router";

import { RootStore } from "app/rootStore";
import { ID } from "shared/interfaces/common";
import RouteValue from "./models/routesValue";
import routes from "./routes";
import routeNames from "./constants/routeNames";

export function findRouteByName(location: string): RouteValue | undefined {
    return find(
        routes,
        route =>
            !!matchPath(location, {
                path: route.name,
                exact: route.exact,
                strict: false,
            })
    );
}

export function navigateOnSuccessLogin(rootStore: RootStore): void {
    rootStore.routerStore.push(rootStore.userHomeRoute);
}

export function navigateToUrl(rootStore: RootStore, url: string): void {
    rootStore.routerStore.push(url);
}

export function navigateToLoginPage(rootStore: RootStore): void {
    rootStore.routerStore.push(routeNames.LOGIN);
}

export function navigateOnContinueSignUp(rootStore: RootStore): void {
    rootStore.routerStore.push(routeNames.SIGN_UP.SIGN_UP_CONTINUE);
}

export function currentUserLinkGuard(currentUserId: ID, targetUserId: ID | undefined, returnUrl: string): string {
    if (currentUserId === targetUserId) {
        return routeNames.MY_PROFILE;
    }

    return returnUrl;
}

export function generateAccountLink({
    userId,
    companyId,
}: { userId: ID; companyId?: ID | null } | { userId?: ID | null; companyId: ID }): string {
    if (companyId) {
        return generatePath(routeNames.ADMIN.BUSINESSES.PROFILE.HOME, { id: companyId });
    }

    if (userId) {
        return generatePath(routeNames.ADMIN.USERS.PROFILE, { id: userId });
    }

    return "";
}
